import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { config } from '../config';

@Injectable({
  providedIn: 'root'
})
export class QuizService {

  constructor(private http: HttpClient) { }

  addQuiz(data: any): Observable<any> {
    console.log("Adding QUIZZZZ", data);

    return new Observable<any>((observer) => {
      console.log("Observable");
      let that = this;
      this.http.post(config.baseApiUrl + "quiz", data).subscribe((res: any) => {
        console.log("QUiz response in service", res);
        observer.next(res.data);
        // observer.complete();
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        })

    });

  }

  getQuizByQuizId(quizId): Observable<any> {
    console.log("Getting Quizzes");
    let that = this;
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.get(config.baseApiUrl + "quiz/quiz-details?quizId=" + quizId).subscribe((res: any) => {
        console.log("Get clients : ", res);
        observer.next(res.data);
        observer.complete();
      })
    });
  }

  getQuizzes(sessionId, sessionType): Observable<any> {
    console.log("Getting Quizzes");
    let that = this;
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.get(config.baseApiUrl + "quiz?sessionId=" + sessionId + "&sessionType=" + sessionType).subscribe((res: any) => {
        console.log("Get clients : ", res);
        observer.next(res.data);
        observer.complete();
      })
    });
  }

  getQuizById(id): Observable<any> {
    console.log("Getting Quizz By Id");
    let that = this;
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.get(config.baseApiUrl + "quiz?id=" + id).subscribe((res: any) => {
        console.log("Get clients : ", res);
        observer.next(res.data);
        observer.complete();
      })
    });
  }

  deleteQuiz(quizId): Observable<any> {
    console.log("DELETE QUIZ", quizId);
    return new Observable<any>((observer) => {
      console.log("Observable");
      let that = this;
      this.http.delete(config.baseApiUrl + "quiz?quizId=" + quizId).subscribe((res: any) => {

        observer.next(res.data);
        // observer.complete();
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        })

    });

  }

  getQuestionsByQuizId(quizId): Observable<any> {
    console.log("Getting Quizzes");
    let that = this;
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.get(config.baseApiUrl + "question?quizId=" + quizId).subscribe((res: any) => {
        console.log("Get clients : ", res);
        observer.next(res);
        observer.complete();
      })
    });
  }

  updateQuizById(data: any): Observable<any> {
    console.log("Adding location", data);
    return new Observable<any>((observer) => {
      console.log("Observable");
      let that = this;
      this.http.put(config.baseApiUrl + "quiz", data).subscribe((res: any) => {
        console.log("Received Sending = ", res.data)
        observer.next(res.data);
        observer.complete();
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        })

    });

  }

  addQuestion(data: any): Observable<any> {
    console.log("Adding QUESTIONS", data);

    return new Observable<any>((observer) => {
      console.log("Observable");
      let that = this;
      this.http.post(config.baseApiUrl + "quiz/question", data).subscribe((res: any) => {
        console.log("QUiz response in service", res);
        observer.next(res.data);
        // observer.complete();
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        })

    });

  }

  deleteQuestion(quizId, questionId) {
    return new Observable((observer) => {
      this.http.delete(config.baseApiUrl + "quiz/question?quizId=" + quizId + "&questionId=" + questionId).subscribe((res: any) => {
        observer.next(res.data);
        // observer.complete();
      }, err => {
        observer.error(err)
      }, () => {
        observer.complete();
      })

    })
  }
  // LEARNERS
  addLearnerAns(data: any): Observable<any> {
    console.log("Adding LEARNER ANSWERS", data);

    return new Observable<any>((observer) => {
      console.log("Observable");
      let that = this;
      this.http.post(config.baseApiUrl + "quiz/submit", data).subscribe((res: any) => {
        console.log("QUiz response in service", res);
        observer.next(res);
        // observer.complete();
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        })

    });
  }

  getLearnerAns(quizId, learnerId, jobId): Observable<any> {
    console.log("Getting Quizzes");
    let that = this;
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.get(config.baseApiUrl + "quiz/submit?quizId=" + quizId + "&learnerId=" + learnerId + "&jobId=" + jobId).subscribe((res: any) => {
        console.log("Get clients : ", res);
        observer.next(res);
        observer.complete();
      })
    });
  }

  editLearnerAns(data): Observable<any> {
    console.log("Adding location", data);
    return new Observable<any>((observer) => {
      console.log("Observable");
      let that = this;
      this.http.put(config.baseApiUrl + "quiz/submit", data).subscribe((res: any) => {
        console.log("Received Sending = ", res.data)
        observer.next(res);
        observer.complete();
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        })

    });
  }
  getLearnersWithStatus(jobId) {
    console.log("Getting LEARNERS");
    let that = this;
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.get(config.baseApiUrl + "quiz/status?jobId=" + jobId).subscribe((res: any) => {
        console.log("Get LEARNERS : ", res);
        observer.next(res);
        observer.complete();
      })
    });
  }

  // getLearnerWithSessionIdGroup(jobId){
  //   console.log("Getting LEARNERS");
  //   let that = this;
  //   return new Observable<any>((observer) => {
  //     console.log("Observable");
  //     this.http.get(config.baseApiUrl + "quiz/status-group?jobId=" + jobId).subscribe((res: any) => {
  //       console.log("Get LEARNERS : ", res);
  //       observer.next(res);
  //       observer.complete();
  //     })
  //   });
  // }

  portfolioSubmission(body) {
    console.log("Getting files");
    let that = this;
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.post(config.baseApiUrl + "quiz/submission/job", body).subscribe((res: any) => {
        console.log("Get materials : ", res);
        observer.next(res.data.assignment);
        observer.complete();
      })

    });
  }

  updateAssessment(data): Observable<any> {
    console.log("Adding LEARNER ANSWERS", data);
    return new Observable<any>((observer) => {
      console.log("Observable");
      let that = this;
      this.http.post(config.baseApiUrl + "quiz/submit-assessment", data).subscribe((res: any) => {
        console.log("QUiz response in service", res);
        observer.next(res.data);
        // observer.complete();
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        })
    });
  }

}
